import { CommonModule } from '@angular/common'
import { Component, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DdcDesktopDialogComponent } from '../ddc-desktop-dialog/ddc-desktop-dialog.component'
import { DdcMobileSheetComponent } from '../ddc-mobile-sheet/ddc-mobile-sheet.component'

@Component({
  selector: 'ddc-button-ai',
  templateUrl: './ddc-button-ai.component.html',
  styleUrls: ['./ddc-button-ai.component.scss'],
  imports: [AngularMaterialsModules, CommonModule],
})
export class DdcButtonAiComponent implements OnDestroy {
  @Input() _label: string = 'Ask Lingo AI'
  @Input() _mode: string | null = null
  @Output() upgradeOpened = new EventEmitter<void>()

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private _themeSubscription: Subscription

  get logoSrc(): string {
    if (this._isDarkTheme) {
      return 'assets/media/logos/lingo_logo_dark.png'
    }
    return 'assets/media/logos/lingo_logo_light.png'
  }

  private _isMobile = false

  constructor(
    public themeService: ThemeService,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this._themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  ngOnDestroy(): void {
    this._themeSubscription.unsubscribe()
  }

  @HostListener('window:resize')
  onResize(): void {
    this._isMobile = window.innerWidth < 1224
  }

  navigateToLingo(): void {
    this.router.navigate(['/lingo'], this._mode ? { queryParams: { mode: this._mode } } : {})
  }

  openUpgradeDialog(): void {
    if (this._isMobile) {
      const dialogConfig = new MatDialogConfig()
      const themeClass = this._isDarkTheme
        ? Themes.DARK
        : this._isPaperTheme
          ? Themes.PAPER
          : Themes.LIGHT
      dialogConfig.panelClass = ['mobile-sheet-container', themeClass]
      dialogConfig.position = { bottom: '0' }
      dialogConfig.width = '100%'
      dialogConfig.height = '80vh'
      dialogConfig.maxWidth = '100vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.backdropClass = 'mobile-sheet-backdrop'
      dialogConfig.enterAnimationDuration = '300ms'
      dialogConfig.exitAnimationDuration = '200ms'
      dialogConfig.data = { type: 'upgrade' }
      this.dialog.open(DdcMobileSheetComponent, dialogConfig)
    } else {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = '600px'
      dialogConfig.maxWidth = '90vw'
      dialogConfig.hasBackdrop = true
      dialogConfig.data = { type: 'upgrade' }
      this.dialog.open(DdcDesktopDialogComponent, dialogConfig)
    }
    this.upgradeOpened.emit()
  }
}
